module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/180x180_icon-5e3f8e681736e7df25c898a869c8c402.png";